<template>
    <div :class="{ 'comment-main': true, 'fix': showProductStatus }">
        <Spin size="large" fix v-if="loading"></Spin>
        <title-component @showProductTc="changeProductTc(true)" :dealName="dealName"></title-component>
        <filter-component :did="did"></filter-component>
        <list-component :did="did" @changeLoading="changeLoading"></list-component>
        <product-component v-if="showProductStatus" @closeProductTc="changeProductTc(false)" :did="did" :businessType="businessType" :businessTypeName="businessTypeName"></product-component>
    </div>
</template>

<style lang="postcss" scoped>
    * {
        margin: 0;
        padding: 0;
    }
    .comment-main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 10%;
        &.fix {
            position: relative;
        }
    }
</style>

<script>
    import TitleComponent from './components/title/Title.vue'
    import FilterComponent from './components/filter/Filter.vue'
    import ListComponent from './components/list/List.vue'
    import ProductComponent from './components/product/Product.vue'
    import Comment from 'api/comment'

    export default {
        components: {
            TitleComponent,
            FilterComponent,
            ListComponent,
            ProductComponent
        },
        data () {
            const data = {
                did: '',
                dealName: '',
                businessType: '', // 业务线 2 门票 3 跟团 4 酒景
                businessTypeName: '',
                loading: false, // 加载动画
                showProductStatus: false // 是否显示切换产品弹层
            }
            data.businessTypeName = this.$route.params.type || this.$route.meta.type;
            switch (data.businessTypeName) {
                case 'ticket': data.businessType = 2
                    break
                case 'gty': data.businessType = 3
                    break
                case 'jiujing': data.businessType = 4
                    break
                default: window.location.href = '/'
            }
            Comment.getDefaultProduct(data.businessType)
                .then((res) => {
                    if (res.data[0].dealId && res.data[0].dealName) {
                        data.did = res.data[0].dealId
                        data.dealName = res.data[0].dealName
                        this.$router.push({
                            name: data.businessTypeName + 'reviewDetail',
                            params: {
                                type: data.businessTypeName,
                                id: data.did,
                                name: data.dealName
                            }
                        })
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: '未获取到产品ID或名称'
                        })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            return data
        },
        watch: {
            // 监听路由变化
            '$route' () {
                this.did = this.$route.params.id
                this.dealName = this.$route.params.name
                this.showProductStatus = false
            }
        },
        methods: {
            // 加载动画，status传入true or false
            changeLoading (status) {
                this.loading = status
            },

            // 显示或隐藏切换产品弹层，status传入true or false
            changeProductTc (status) {
                this.showProductStatus = status
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?c664dfea